import React, { useState, useEffect } from "react";
import { MDBInput } from "mdb-react-ui-kit";
import ReactDatetime from "react-datetime";
import Select from "react-select";

import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Badge,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  UncontrolledTooltip,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Smile from "../../assets/img/smile.png";
import Attach from "../../assets/img/attach.png";
import Send from "../../assets/img/send1.svg";
import Whatsap from "../../assets/img/whatsapp.svg";

import {
  WHATSAPP_CAMPAIGN_NAMES,
  WHATSAPP_CAMPAIGN_DOWNLOAD,
  WHATSAPP_CAMPAIGN_LIST,
  WHATSAPP_DETAIL_REPORTS,
  WHATSAPP_USER_RESPONSE,
  WHATSAPP_CHAT_HISTORY,
  BASE_URL_CHAT_APP,
  CHANNEL_CLIENT_CHNLTYPE,
  WHATSAPP_USER_RESPONSE_EXCEL,
  WHATSAPP_CATEGORY_SUMMARY
} from "../../constants";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import axios from "axios";
import moment from "moment";
import NotificationAlert from "react-notification-alert";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import apiService from "../../variables/apiService";

let templates = [];
let senderids = [];
const localJson = localStorage.getItem("user");
const user = JSON.parse(localJson);

const fltrdrpdwn=[
{label:"Select All",value:"all"},
{label:"Mobile No",value:"mobile"},
{label:"Code",value:"code"},
{label:"Type",value:"type"},
{label:"Id",value:"id"},
{label:"Status",value:"status"},
{label:"Category",value:"category"},

]
const Detailedreports = () => {
  const [search, setSearch] = useState({
    fromdate: "",
    todate: "",
    campaignname: "",
    mobile: "",
    templateid: "",
    senderid: "",
    advfltrname:{label:"Select All",value:"all"},
    advfltrval:""
  });
  let selectedDate = "";
  const [iscountryselect,setcountry]=useState("")
  const [singleSelect, setsingleSelect] = useState(null);
  const [name, setName] = useState([]);
  const [cname, setCName] = useState([]);

  const [showList, setShowList] = useState(false);
  const [whatsappLst, setWhatsappLst] = useState([]);
  const [whatsappLstC, setWhatsappLstC] = useState([]);
  const [chatHistory, setChatHistory] = useState([]);

  const [currentPage, setCurrentPage] = React.useState(1);

  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });

  const notificationAlertRef = React.useRef(null);
  const [errorhandle, setErrorHandle] = useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [filterList, setFilterLst] = useState([]);
  const [templateSelect, setTemplateSelect] = useState(null);
  const [selectedDrpdwn, setSelectedDrpdwn] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [sendMsg, setSendMsg] = useState({ number: "", message: "" });
  const [channel, setChannel] = useState([]);
  const drpdwns = [
    { value: "Inbound", label: "Inbound" },
    { value: "Outbound", label: "Outbound" },
  ];
  const [categorysummary,setCategorysummary]=useState([])

  useEffect(() => {
    getWhatsappNames();
    fetchChanelsbyClient();
    // getWhatsappList(currentPage);
  }, []);

  const getWhatsappNames = () => {
    apiService
      .getData(WHATSAPP_CAMPAIGN_NAMES)
      .then((res) => {
        setName(res.data.message);
        setCName(res.data.message);
      })
      .catch((err) => console.log("error===>", err));
  };

  const fetchChanelsbyClient = () => {
    //setIsLoading(true)

    const payload = {
      channels_type: "whatsapp",
      clintId: user?.client,
    };

    apiService
      .postData(CHANNEL_CLIENT_CHNLTYPE, payload)
      .then((res) => {
        templates = [];

        setChannel(res?.data);

        res?.data?.map((wtsap, i) => {
          wtsap?.template &&
            templates.push({ value: wtsap?.template, label: wtsap?.template });
        });

        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        let options = {};
        options = {
          place: "tr",
          message: "Templates Not Found",
          type: "warning",
          autoDismiss: 2,
        };
        notificationAlertRef?.current?.notificationAlert(options);
      });
  };

  const changeSender = (data) => {
    senderids = [];
    const chnl = channel.filter((item) => item.template == data.value);

    const senderid = chnl[0]?.senderid?.split(",");
    for (let i = 0; i < senderid?.length; i++) {
      senderids.push({ label: senderid[i], value: senderid[i] });
    }

    setSearch((prev) => ({ ...prev, templateid: data, senderid: "" }));
  };

  const validating = () => {
    let errors = {};
    let fromdate = moment(search?.fromdate).format("YYYY-MM-DD");
    let todate = moment(search?.todate).format("YYYY-MM-DD");
    if (!search?.fromdate) {
      errors.fromdate = "Please Select From Date";
    }
    if (!search?.todate) {
      errors.todate = "Please Select To Date";
    } else if (todate < fromdate) {
      errors.todate = "To date should be greater than or equal to from date";
    }
    if (!singleSelect?.value) {
      errors.singleSelect = "Please Select Response";
    }

    return errors;
  };

  const getWhatsappList = (page) => {
    const isValid = validating();
    setErrorHandle(isValid);
    if (Object.keys(isValid).length === 0) {
      setIsLoading(true);
      const lclStrge = localStorage.getItem("user");
      const user = JSON.parse(lclStrge);
      let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
      let todate = moment(search.todate).format("YYYY-MM-DD");
      const sender_id = user?.sender_id;
      const type = singleSelect?.value;
      const advfltkey = search?.advfltrname?.value;
      const advfltrval = search?.advfltrval;


      setCurrentPage(page);
      apiService
        // .get(WHATSAPP_USER_RESPONSE + `?fromdate=${fromdate}&todate=${todate}&campaign=${search?.campaignname}&template=${search?.templateid?.value}&mobile=${search.mobile}&senderid=${search?.senderid?.value}&page=` + page)
        .getData(
          WHATSAPP_USER_RESPONSE +
            `?fromdate=${fromdate}&todate=${todate}&senderid=${sender_id}&page=${page}&type=${type}&advfltkey=${advfltkey}&advfltval=${advfltrval}`
        )

        .then((res) => {
          setWhatsappLst(res?.data);
          setWhatsappLstC(res?.data);
          setIsLoading(false);
          setFilterLst(res?.data);
        })
        .catch((err) => {
          console.log("error===>", err);
          setIsLoading(false);
          setWhatsappLst([]);
        });
    }
  };

  const getcategory=async()=>{

    const lclStrge = localStorage.getItem("user");
      const user = JSON.parse(lclStrge);
      
      const payload={
        fromdate:moment(search.fromdate).format("YYYY-MM-DD"),
        todate : moment(search.todate).format("YYYY-MM-DD"),
        senderid : user?.sender_id
      }

      let obj = await apiService
      .postData(WHATSAPP_CATEGORY_SUMMARY, payload)
      .then((res) => {
        setCategorysummary(res?.data?.message)
        setcountry(res?.data?.message[0].name)
       
      })

      .catch((err) => {});
  }

  const generateXcel = (page) => {
    const isValid = validating();
    setErrorHandle(isValid);
    if (Object.keys(isValid).length === 0) {
      if (search?.fromdate) {
        let selectedDate = moment(search.date).format("YYYY-MM-DD");

        const lclStrge = localStorage.getItem("user");
        const user = JSON.parse(lclStrge);
        let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
        let todate = moment(search.todate).format("YYYY-MM-DD");
        const sender_id = user?.sender_id;
        console.log("sender_id", sender_id);
        const type = singleSelect?.value;
        setIsLoading(true);
        setCurrentPage(page);
        console.log(WHATSAPP_USER_RESPONSE_EXCEL +
            `?fromdate=${fromdate}&todate=${todate}&senderid=${sender_id}&type=${type}`);
        axios.get(
          WHATSAPP_USER_RESPONSE_EXCEL +
            `?fromdate=${fromdate}&todate=${todate}&senderid=${sender_id}&type=${type}`,
          {
            responseType: "blob",
            timeout: 0,
            transformResponse: r => r, // bypass interceptors
          }
        )
        .then(res => {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
        
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "whatsapp_report_"+fromdate+".xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
          setIsLoading(false);      
        });
        
      }
    } else {
      setValidate({
        message: "please enter details",
        notValid: true,
      });
    }
  };

  const bufferToString = (bufferData) => {
    if (!bufferData) return "";
  
    return new TextDecoder("utf-8").decode(
      new Uint8Array(bufferData)
    );
  };
  
  const exportToCSVnew = (apiData) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
  
    const formattedData = apiData.map(item => ({
      RequestType: item.RequestType || "Whatsapp",
      bound: item.bound,
      senderid: item.senderid,
      destination: item.destination,
      externalMessageId: item.externalMessageId,
      status: item.status,

  
      TEXT: item.TEXT?.data
        ? bufferToString(item.TEXT.data)
        : ""
    }));
  
    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "whatsapp_messages" + fileExtension);
  };
  
  
  const exportToCSV = (apiData) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, search.fromdate + fileExtension);
  };

  const filterData = (e) => {
    let filter = e.target.value;
    // let a = filterList?.message.filter((item,index)=>{console.log(typeof(c)) })
    let a = whatsappLstC?.message?.filter((item) =>
      item?.msisdn?.includes(filter)
    );

    setWhatsappLst({
      message: a,
    });
  };

  const toDatevalidation = (todt) => {
    setSearch({ ...search, todate: todt });
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(todt).format("YYYY-MM-DD");

    if (todate >= fromdate) {
      setValidate({
        message: "",
        notValid: false,
      });
    } else {
      setValidate({
        message: "To date should be greater than or equal to from date",
        notValid: true,
      });
    }
  };
  var valid = function( current ){
  var yesterday = moment().subtract( 0, 'day' );

      return current.isBefore( yesterday );
  };

  return (
    <>
      <div className="content pb-0">
        <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
        <Row>
          <Col md="12">
            <Card className="mb-2">
              <CardBody>
                <NotificationAlert ref={notificationAlertRef} />
                <Row>
                  <Col md="2" sm="12">
                    <p className="category">From Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.fromdate}
                      onChange={(val) => {
                        setSearch({ ...search, fromdate: val._d });
                        setCurrentPage(1)
                      }}
                    
                      isValidDate={ valid }
                    />
                    <span style={{ color: "red" }}>
                      {errorhandle?.fromdate}
                    </span>
                  </Col>
                  <Col md="2" sm="12">
                    <p className="category">To Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.todate}
                      onChange={(val) => {
                        setSearch({ ...search, todate: val._d });
                        toDatevalidation(val._d);
                        setCurrentPage(1)
                      }}
                      isValidDate={ valid }
                    />
                    <span style={{ color: "red" }}>{errorhandle?.todate}</span>
                  </Col>
                  <Col md="2" sm="12" style={{zIndex:99999999999}}>
                    <p className="category">Select </p>
                    <Select
                    style={{zIndex:99999999999}}
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="singleSelect"
                      value={singleSelect}
                      onChange={(value) => {
                        setsingleSelect(value);
                      }}
                      options={drpdwns}
                      placeholder="Select"
                    />
                    <span style={{ color: "red" }}>
                      {errorhandle?.singleSelect}
                    </span>
                  </Col>

                  {singleSelect?.value == 2 && (
                    <>
                      <Col md="4" sm="12">
                        <p className="category">
                          Select Template<suf style={{ color: "red" }}>*</suf>{" "}
                        </p>
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="templateSelect"
                          value={search.templateid}
                          onChange={(value) => changeSender(value)}
                          options={templates}
                          placeholder="Select"
                        />
                        {errorhandle?.templateid && (
                          <span style={{ color: "red" }}>
                            {errorhandle?.templateid}
                          </span>
                        )}
                      </Col>
                      <Col md="4" sm="12">
                        <p className="category">
                          Select Sender<suf style={{ color: "red" }}>*</suf>{" "}
                        </p>
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="senderSelect"
                          value={search?.senderid}
                          onChange={(value) =>
                            setSearch((prev) => ({ ...prev, senderid: value }))
                          }
                          options={senderids}
                          placeholder="Select"
                        />
                      
                      </Col>
                    </>
                  )}
                      <Col md="2" sm="12" style={{zIndex:99999999999}}>
                    <p className="category">Select </p>
                    <Select
                    style={{zIndex:99999999999}}
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="singleSelect"
                      value={search.advfltrname}
                      onChange={(value) =>
                        setSearch((prev) => ({ ...prev, advfltrname: value,advfltrval:"" }))
                      }
                      options={fltrdrpdwn}
                      placeholder="Select"
                    />
                    
                  </Col>
                  {
                    search?.advfltrname?.value?.toLowerCase()!="all"&& <Col md="2" sm="12">
                    <p className="category">Type here </p>
                      <Input type="text" placeholder="Type here" value={search?.advfltrval} onChange={(e)=>setSearch((prev) => ({ ...prev, advfltrval: e.target.value }))}/>
                    </Col>
                  }
                 
                  <Col md="2" sm="6" className="pull-right">
                    <Button
                      color="primary "
                      className="mt-4 btn btn-icon animation-on-hover"
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => {getWhatsappList(currentPage);getcategory()}}
                    >
                      <i className="tim-icons icon-double-right" />
                    </Button>
                    <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltipsubmit"
                    >
                      Submit
                    </UncontrolledTooltip>
                    {
                      whatsappLst?.message?.length > 0&&
                    <>
                    <Button
                      className=" btn-primary  btn-simple btn-icon btn-round mt-4"
                      color="primary"
                      data-placement="top"
                      id="tooltippdf"
                      type="button"
                      onClick={() => generateXcel(currentPage)}
                    >
                      <i className="tim-icons icon-cloud-download-93" />
                    </Button>
                   
                    <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltippdf"
                    >
                      Export
                    </UncontrolledTooltip>

                    <Button
                      className=" btn-primary  btn-simple btn-icon btn-round mt-4"
                      color="primary"
                      data-placement="top"
                      id="tooltipexcel"
                      type="button"
                      onClick={() => setShowModal(!showModal)}
                    >
                      <i className="tim-icons icon-single-copy-04" />
                    </Button>

                    <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltipexcel"
                    >
                      Country Report
                    </UncontrolledTooltip>
                    </>
                  }
                  </Col>
                  
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
              <CardBody className="mb-0">
                <Modal isOpen={showModal} className="roles-popup" style={{width:"30%"}}>
                  <div
                    className="modal-header justify-content-center"
                    style={{
                      backgroundColor: " rgba(233, 233, 233, 0.9294117647)",
                    }}
                  >
                    <button
                      aria-hidden={true}
                      className="close"
                      data-dismiss="modal"
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                      <i className="tim-icons icon-simple-remove" />
                    </button>
                    <h3 className="title title-up multicolortext">
                      Country Wise Report
                     
                    </h3>
                  </div>
                  <ModalBody className="modelbody">
                  
                     
                    { categorysummary?.length>0?<Row>
                  <Col md="12" className=" smscard">
                    <div>
                   
                      {
                      categorysummary?.map((item,index)=> {
                      
                       return item.count!=0&&<>
                        <p onClick={()=>iscountryselect==item.name?setcountry(""):setcountry(item.name)}>{iscountryselect.toLowerCase()==item?.name?.toLocaleLowerCase()?"-":"+"} {item.name}<span>{item.count || 0}</span></p>
                        {
                          item?.contries?.map((countrie,i)=>
                          {
                            return (iscountryselect.toLowerCase()==item?.name?.toLocaleLowerCase()&&item.count!=0)&& <p className="country-list">   {countrie.name}<span>{countrie.count || 0}</span></p>
                          }
                          )
                        }
                       
                     </>
                      }
                        
                        )
                      }
                     
                    </div>
                  </Col>
                
                  
                </Row>:
                <Row>
                <Col md="12" className=" smscard">
                  <div>
                    <h3>No Records Availble</h3>
                    </div>
                    </Col>
                    </Row>
                }
                   
                  </ModalBody>
                  <ModalFooter>
                    
                  </ModalFooter>
                </Modal>
             
                
                <TableContainer component={Paper} className="tableheight_nopagi">
                  <Table className="table table-striped"
                  >
                    <thead class="bg-light sticky-top" style={{top:""}}>
                      <tr>
                        <th>Sno </th>
                        <th> Date</th>
                        <th> Code </th>
                        <th> Mobile No</th>
                        <th> MsgId</th>
                        <th> Direction </th>
                        <th> Type </th>
                        <th> Content</th>
                        <th> Id</th>
                        <th> Name</th>
                        <th> Status</th>
                        <th> Remarks</th>
                        <th> category</th>
                      </tr>
                     
                    </thead>
                    <tbody>
                      {whatsappLst?.message?.length > 0 ? (
                        whatsappLst?.message?.map((item, index) => {
                          let templateid = "";
                          let content ="";
                          if (item.ID === "whatsapp_file_pull") {
                            templateid = "1709";
                          } else if (item.ID === "whatsapp_file_recall") {
                            templateid = "1708";
                          } else if (
                            item.ID === "whatsapp_file_cancel_check_1"
                          ) {
                            templateid = "1816";
                          } else if (
                            item.ID === "whatsapp_file_dismiss_check_1"
                          ) {
                            templateid = "1814";
                          } else if (
                            item.ID === "whatsapp_file_return_check_1"
                          ) {
                            templateid = "1818";
                          } else if (item.ID === "whatsappsharetemplate") {
                            templateid = "1802";
                          } else if (item.ID === "whatsapptask_received") {
                            templateid = "1812";
                          }
                          else if (item.ID === "OTP") {
                            templateid = "1706";
                          }
                          const Contenttrim = item.Content.trim();
                         
                          const contntJson =
                          (Contenttrim.startsWith('{') && Contenttrim.endsWith('}')) ||
                          (Contenttrim.startsWith('[') && Contenttrim.endsWith(']'));
                         if(contntJson){
                          const tempcont = JSON.parse(item.Content);
                          if (String(user?.sender_id) === "917303482071") {
                            tempcont?.template?.components?.forEach((component) => {
                              component?.parameters?.forEach((parameter) => {
                                if (typeof parameter?.text === "string") {
                                  parameter.text = "*".repeat(parameter.text.length);
                                }
                              });
                            });
                          }
                          content = JSON.stringify(tempcont?.template?.components);
                         }else{
                          content = item.Content;
                         }
                         
                          return (
                            <>
                              <tr>
                                <td style={{ width: "15%" }}>{index + 1}</td>
                                <td style={{ width: "15%" }}>
                                  {moment(item.CreatedDate).format(
                                    "YYYY-MM-DD H:m"
                                  )}
                                </td>
                                <td>{item?.Code}</td>
                                <td style={{ width: "15%" }}>
                                  {String(user?.sender_id) === "917303482071"
                                    ? `${String(item.msisdn ?? "").slice(0, -4)}****`
                                    : item.msisdn}
                                </td>
                                <td>{item.msgid}</td>
                                <td>{item.Direction}</td>
                                <td>{(item.ID=="1706"?"OTP":item.ID) || "NA"}</td>
                                <td>{content}</td>
                                <td>{templateid==""?item.ID:templateid}</td>
                                <td>{item?.name || "NA"}</td>
                                <td>{item.status}</td>
                                <td>{item.status_response || ""}</td>
                                <td>{item.Category}</td>
                              </tr>
                            </>
                          );
                        })
                      ) : (
                        <tr>
                          <td colspan="13">No Records Availble</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </TableContainer>
              </CardBody>
              {whatsappLst?.numOfPages > 0 && (
                <div style={{ width: "30%", marginLeft: "auto" }}>
                  <ResponsivePagination
                    current={currentPage}
                    total={whatsappLst?.numOfPages}
                    onPageChange={(newPage) => {
                      getWhatsappList(newPage);
                    }}
                  />
                </div>
              )}
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Detailedreports;
